import { IRacingSecretaryStallApplicationState } from "../../interfaces/RacingSecretaryStallApplication";
import {
  SET_STALL_APPLICATION_DETAILS_STATE,
  SET_UNSAVED_CHANGES_POPUP_STATE,
  TAction
} from "../actions/racingSecretaryStallApplication";

const initialState: IRacingSecretaryStallApplicationState = {
  stallApplicationDetailsState: false,
  unsavedChangesPopupState: false
};

export default (
  state: IRacingSecretaryStallApplicationState = initialState,
  action: TAction
): IRacingSecretaryStallApplicationState => {
  switch (action.type) {
    case SET_STALL_APPLICATION_DETAILS_STATE: {
      return {
        ...state,
        stallApplicationDetailsState: action.stallApplicationDetailsState
      };
    }
    case SET_UNSAVED_CHANGES_POPUP_STATE: {
      return {
        ...state,
        unsavedChangesPopupState: action.unsavedChangesPopupState
      };
    }
    default:
      return state;
  }
};
